import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../design/resetPassword.css';

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [userInfo, setUserInfo] = useState(null); 
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get('token');
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      axios
        .get(`https://api.deliquentauction.com/auth/reset-password/user-info?token=${tokenFromUrl}`)
        .then((res) => {
          setUserInfo(res.data);
        })
        .catch((err) => {
          setErrorMessage('Invalid or expired reset link.');
        });
    } else {
      setErrorMessage('Invalid reset link.');
    }
  }, [location]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
  
    if (!newPassword) {
      setErrorMessage('Please enter a new password.');
      return;
    }
  
    try {
      const response = await axios.put('https://api.deliquentauction.com/auth/reset-password/', {
        token,         
        new_password: newPassword 
      });
  
      if (response.status === 200) {
        alert('Your password has been reset successfully!');
        navigate('/login');
      }
    } catch (error) {
      console.log('Backend error:', error.response?.data);
      if (error.response?.data?.detail) {
        const errorMessage = error.response.data.detail[0].msg || 'Something went wrong.';
        setErrorMessage(errorMessage);
      } else {
        setErrorMessage('Something went wrong.');
      }
    }
  };
  
  return (
    <div className="reset-password-container">
      <img src="/logo.png" alt="Logo" />
      {errorMessage && <p>{errorMessage}</p>}
      {userInfo && (
        <form onSubmit={handleResetPassword}>
          <div>
            <label>Email:</label>
            <input
              type="text"
              value={userInfo.email}
              readOnly
            />
          </div>
          <div>
            <label>Username:</label>
            <input
              type="text"
              value={userInfo.username}
              readOnly
            />
          </div>
          <div>
            <label>New Password:</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter your new password"
              required
            />
          </div>
          <div>
            <label>Confirm New Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your new password"
              required
            />
          </div>
          <button type="submit">Submit</button>
        </form>
      )}
      <div>
        <p>Remember your password? <a href="/login">Login</a></p>
      </div>
    </div>
    
  );
};

export default ResetPasswordPage;
